import { isEmpty, isString } from "lodash";
import { getUserToken } from "../helpers";
import { ls } from "@src/Services/Helpers/LocalStorageEnc";
import { filterBuilder } from "@src/Services/Helpers/Actions";

export const attachAuthToken = (config) => {
  const token = getUserToken();
  if (!isEmpty(token) && isString(token)) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`
    };
  }
  return config;
};

export const buildRequestParams = (config) => {
  const additionalParams = ls.getItem("additionalParams") || {};
  const filteredBranches = config.useFilteredBranches ? ls.getItem("filteredBranches") || [] : [];
  const { data = undefined, apiParams = {}, method } = config;
  const params = { ...apiParams, filtered_branches_ids: filteredBranches };

  if (config.withAdditionalParams) {
    if (method === "get") {
      const combinedParams = { ...additionalParams, ...params };
      if (combinedParams) {
        const queryStr = filterBuilder(combinedParams);
        config.url = `${config.url}?${queryStr}`;
      }
    } else if (["post", "put", "patch", "delete"].includes(method)) {
      config.data = { ...data, ...additionalParams };
    }
  } else {
    config.url = `${config.url}?${filterBuilder(params)}`;
  }
  return config;
};
